import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import WhatsAppButton from './components/WhatsAppButton'
import Home from './pages/Home'
import About from './pages/About'
import Prayer from './pages/Prayer'
import Testimonials from './pages/Testimonials'
import Sermons from './pages/Sermons'
import BibleSchool from './pages/BibleSchool'
import Events from './pages/Events'
import Worship from './pages/Worship'
import Programacao from './pages/Programacao'
import Contact from './pages/Contact'
import MyAccount from './pages/MyAccount'
import { AdminRoute } from './components/admin/AdminRoute'
import Dashboard from './pages/admin/Dashboard'
import PrayersManagement from './pages/admin/PrayersManagement'
import TestimonialsManagement from './pages/admin/TestimonialsManagement'
import SermonsManagement from './pages/admin/SermonsManagement'
import UsersManagement from './pages/admin/UsersManagement'
import AdminLogs from './pages/admin/AdminLogs'
import EventsManagement from './pages/admin/EventsManagement'
import WorshipManagement from './pages/admin/WorshipManagement'
import BibleSchoolManagement from './pages/admin/BibleSchoolManagement'
import ProgramacaoManagement from './pages/admin/ProgramacaoManagement'
import ContactsManagement from './pages/admin/ContactsManagement'

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white">
        <Navbar />
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/oracao" element={<Prayer />} />
          <Route path="/testemunhos" element={<Testimonials />} />
          <Route path="/palavra-de-deus" element={<Sermons />} />
          <Route path="/escola-biblica" element={<BibleSchool />} />
          <Route path="/eventos" element={<Events />} />
          <Route path="/louvores" element={<Worship />} />
          <Route path="/programacao" element={<Programacao />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/minha-conta" element={<MyAccount />} />

          {/* Rotas Administrativas Protegidas */}
          <Route path="/admin" element={<AdminRoute><Dashboard /></AdminRoute>} />
          <Route path="/admin/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
          <Route path="/admin/prayers" element={<AdminRoute><PrayersManagement /></AdminRoute>} />
          <Route path="/admin/testemunhos" element={<AdminRoute><TestimonialsManagement /></AdminRoute>} />
          <Route path="/admin/sermons" element={<AdminRoute><SermonsManagement /></AdminRoute>} />
          <Route path="/admin/users" element={<AdminRoute><UsersManagement /></AdminRoute>} />
          <Route path="/admin/logs" element={<AdminRoute><AdminLogs /></AdminRoute>} />
          <Route path="/admin/events" element={<AdminRoute><EventsManagement /></AdminRoute>} />
          <Route path="/admin/worship" element={<AdminRoute><WorshipManagement /></AdminRoute>} />
          <Route path="/admin/bible-school" element={<AdminRoute><BibleSchoolManagement /></AdminRoute>} />
          <Route path="/admin/programacao" element={<AdminRoute><ProgramacaoManagement /></AdminRoute>} />
          <Route path="/admin/contacts" element={<AdminRoute><ContactsManagement /></AdminRoute>} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  )
}

export default App
